interface IconProps {
    width?: string;
    height?: string;
    className?: string;
}

const MaintenanceIcon = ({ width = '20', height = '20', className = '' }: IconProps) => {
    return (
        <span className={className}>
            <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.00078 6.20001L2.60078 3.86667L3.53411 2.93334L5.86745 4.33334V5.26667L8.26745 7.66667C8.26745 7.73334 8.26745 7.80001 8.26745 7.86667L7.40078 8.66667L4.93411 6.20001H4.00078ZM14.0008 11.8667C13.8008 11.8667 13.6674 11.8667 13.4674 11.8667C13.0008 11.8667 12.6008 11.8 12.2008 11.7333L10.8008 13.3333L13.9341 16.8667C14.6674 17.6667 15.9341 17.7333 16.6674 16.9333C17.4674 16.1333 17.4008 14.9333 16.6008 14.2L14.0008 11.8667ZM16.2674 9.33334C17.3341 8.26667 17.6674 6.66667 17.2674 5.26667C17.2008 5.00001 16.8674 4.93334 16.7341 5.13334L14.4008 7.46667L12.5341 5.60001L14.8674 3.26667C15.0674 3.06667 15.0008 2.80001 14.7341 2.73334C13.3341 2.26667 11.7341 2.60001 10.6674 3.73334C9.46745 4.93334 9.20078 6.80001 9.86745 8.26667L3.20078 14.2C2.40078 14.9333 2.33411 16.2 3.13411 16.9333C3.93411 17.7333 5.13411 17.6667 5.86745 16.8667L11.8008 10.2C13.2674 10.8667 15.0674 10.6 16.2674 9.33334Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
};

export default MaintenanceIcon;
